import * as userLogTypes from "../../types/admin/userLogTypes";

export const getUserLogReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case userLogTypes.GET_USER_LOG_REQUEST:
      return {
        ...state,
        getUserLogLoading: true,
      };
    case userLogTypes.GET_USER_LOG_SUCCESS:
      return {
        ...state,
        getUserLogLoading: false,
        getUserLogInfo: payload,
        getUserLogError: "",
      };
    case userLogTypes.GET_USER_LOG_FAIL:
      return {
        ...state,
        getUserLogLoading: false,
        getUserLogInfo: [],
        getUserLogError: payload,
      };
    default:
      return state;
  }
};
